export type CheckoutFlow = "authed" | "guest";
export type CheckoutPlace = "pricing_card" | "home_pricing_page";

export function getCheckoutTrackingContext(
  pathname: string,
  locale: string = "en"
): {
  checkoutFlow: CheckoutFlow;
  checkoutPlace: CheckoutPlace;
  checkoutLocale: string;
} {
  const checkoutPlace = pathname.includes("/home")
    ? "home_pricing_page"
    : "pricing_card";

  return {
    checkoutFlow: checkoutPlace === "home_pricing_page" ? "authed" : "guest",
    checkoutPlace,
    checkoutLocale: locale || "en",
  };
}

/**
 * Event id for an InitiateCheckout, generated in the browser and passed to the
 * checkout server code so the pixel and Conversions API events deduplicate.
 */
export function createInitiateCheckoutEventId(): string {
  const random =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2)}`;
  return `ic_${random}`;
}
